// Ürün Eşleştirme penceresi (pazaryeri ürünlerini stok kartlarına aktarma) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.productMapping';

export const productMappingModalGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Ürün eşleştirme nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Seçtiğiniz pazaryeri ürünlerinin stokta nasıl açılacağına burada karar verirsiniz: yeni stok kartı, mevcut bir ürüne bağlı alt ürün ya da atlama. Yanlış eşleşme ürünü yanlış stok kartına bağlar. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ürün Eşleştirme ve sayaçlar'),
    list: t(`${G}.regions.list`, 'Pazaryeri ürünleri'),
    form: t(`${G}.regions.form`, 'Eşleştirme, depo ve Mevcut Stok Ürünleri'),
    footer: t(`${G}.regions.footer`, 'İptal / Import'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Ekranı tanıyın'),
      text: t(`${G}.s1.text`, 'Solda seçtiğiniz pazaryeri ürünleri, sağda "Mevcut Stok Ürünleri" listelenir. Üstteki sayaçlar kaç ürünün Yeni Ürün, Otomatik, Elle Seçildi ve Atlandı durumunda olduğunu gösterir. İki listede de arama kutusu, sağda ayrıca Depo Filtresi vardır.'),
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Eşleştirme kriterini seçin'),
      text: t(`${G}.s2.text`, 'Pencere açılınca ürünler kendiliğinden eşleştirilir. "Eşleştirme Kriteri": Tüm Kriterler sırayla barkod, stok kodu (SKU) ve birebir aynı ürün adına bakar; Sadece Ürün Adı / Sadece Stok Kodu / Sadece Barkod yalnız o alana bakar. Kriteri değiştirince eşleştirme baştan yapılır. Eşleşen satır yeşil olur ve altında "Eşleştirilen Ürün" ile eşleşme yöntemi yazar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Ad eşleşmesi yalnız birebir aynı adda olur (büyük/küçük harf fark etmez); benzer adlar eşleşmez.'),
        t(`${G}.s2.tip2`, 'Ortadaki "Otomatik Eşleştir" düğmesi eşleştirmeyi yeniden yapar ve elle yaptığınız değişiklikleri siler. Başlıktaki "Auto Matching" kapalıyken bu düğme tüm ürünleri Yeni Ürün yapar.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Her ürün için işlemi belirleyin'),
      text: t(`${G}.s3.text`, 'Her satırdaki "İşlem" kutusundan seçin: Yeni Ürün, Otomatik Eşleştir, Elle Seç veya Atla. "Elle Seç" seçince ortada "Elle Seçim Modu" açılır; sağdaki listeden bağlanacak stok ürününe tıklayın ("İptal" ile vazgeçersiniz). "Resim" anahtarı ürünün görselinin de aktarılıp aktarılmayacağını belirler.'),
      tips: [
        t(`${G}.s3.tip1`, 'Eşleşmesi olmayan bir satırda "Otomatik Eşleştir" seçerseniz o ürün aktarılmaz.'),
        t(`${G}.s3.tip2`, '"Elle Seç" ile bağladığınız satırlar sayaçta "Elle Seçildi" görünür ama şu anki sürümde aktarıma dahil edilmez. Böyle bir ürünü aktarmak için stok ürününü seçtikten sonra İşlem kutusunu "Otomatik Eşleştir" yapın; seçtiğiniz bağlantı korunur.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. İçe aktarma deposunu seçin'),
      text: t(`${G}.s4.text`, 'Ortadaki "İçe Aktarma Deposu" kutusunda seçtiğiniz depo, aktarılan tüm ürünlere yazılır; ürün bazında farklı depo seçilemez.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Aktarın ve sonucu kontrol edin'),
      text: t(`${G}.s5.text`, '"Import N Products" düğmesi atlananlar dışındaki ürünleri stoka yazar. Yeni Ürün: yeni bir ana stok kartı açılır (ad, barkod, stok kodu, miktar ve satış fiyatı pazaryerinden; stok kodu yoksa PLATFORM-ürünID). Eşleşen ürün: seçilen stok ürününün altında "Ürün adı (PLATFORM)" adlı yeni bir alt ürün kartı açılır; mevcut kartın miktarı ve fiyatı değişmez. Atla: hiçbir kayıt oluşmaz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Açılan kartlarda alış fiyatı satış fiyatının %80\'i, KDV %20 (dahil) olarak yazılır; aktarımdan sonra stok kartlarında bu değerleri düzeltin.'),
        t(`${G}.s5.tip2`, 'İşlem sırasında ilerleme penceresi açılır; bitince aktarılan ürün sayısı mesajla bildirilir ve pencereler kapanır.'),
      ],
    },
  ],
});
